import PageLoaderWrapper from "components/shared/page-loader-wrapper/page-loader-wrapper";
import { Suspense } from "react";

const SuspenseLoader = ({ children }) => (
  <Suspense fallback={<PageLoaderWrapper isLoaded={false} />}>{children}</Suspense>
);

export default SuspenseLoader;
